import { ParsedUrlQuery, ParsedUrlQueryInput } from 'querystring'

export const getUtmParams = (params: ParsedUrlQuery): ParsedUrlQueryInput =>
  Object.entries(params).reduce((acc, [key, val]) => {
    if (key.startsWith('utm')) {
      return {
        ...acc,
        [key]: val
      }
    }
    return acc
  }, {})
